import {makeStyles} from "@fluentui/react-components";
import {pinkTheme} from "../../../styles/mission/theme";
import {CampaignCodeValues} from "../../../constant/mediaCode";
import {useIsFinish} from "../../../stores/useStore";
import {useQuery} from "../../../hooks/useQuery";
import FinishPage from "../common/Finish";
import NshopQuiz from "./NshopQuiz";
import NplaceQuiz from "./NplaceQuiz";
import NplaceSave from "./NplaceSave";
import AccessDeniedPage from "../common/AccessDeniedPage";
import {ExhaustedPage} from "../common/ExhaustedPage";


export type propsType = {
    mediaCode: string
    campaignCode: CampaignCodeValues,
    campaignID: string,
    payload: string,
    uk: string,
    adFallBack: boolean
}

const useStyles = makeStyles({
    root: {
        fontFamily: 'NanumBarunGothic',
        width: '100%',
        height: '100vh',
        backgroundColor: pinkTheme.bgColor100
    },
})

export default function ToktokquizVer2() {
    const query = useQuery()
    const isFinish = useIsFinish()
    const currentPath = window.location.pathname;
    const styles = useStyles()

    const props: propsType = {
        mediaCode: query.get("mediaCode") || "",
        campaignCode: query.get("campaignCode") as CampaignCodeValues,
        campaignID: query.get("campaignID") || "",
        payload: query.get("payload") || "",
        uk: query.get("uk") || "",
        adFallBack: query.get("adFallBack") === "true"
    }

    function Page () {
        if(isFinish && currentPath==='/') {return <FinishPage />}
        else {
            if (!props.adFallBack) return <ExhaustedPage/>
            if (props.campaignCode.includes('nshop_quiz')) return <NshopQuiz {...props}/>
            if (props.campaignCode === 'nplace_quiz') return <NplaceQuiz {...props}/>
            if (props.campaignCode === 'nplace_save') return <NplaceSave {...props}/>
        }
        return <AccessDeniedPage />
    }

    return (
        <div className={styles.root}>
            <Page/>
        </div>
    )
}